import { useMemo } from 'react';

type Params = {
  year: string;
  month: string;
  day: string;
};

export const useAdjustableDays = ({ year, month, day }: Params) => {
  const daysInMonth = useMemo(() => {
    const y = parseInt(year, 10);
    const m = parseInt(month, 10);

    if (!y || !m) return 31;

    return new Date(y, m, 0).getDate(); // ← 月末日を取得（2月など補正）
  }, [year, month]);

  const correctedDay = useMemo(() => {
    const d = parseInt(day, 10);
    return d > daysInMonth ? String(daysInMonth) : day;
  }, [day, daysInMonth]);

  const dayOptions: string[] = useMemo(() => {
    return Array.from({ length: daysInMonth }, (_, i) => String(i + 1));
  }, [daysInMonth]);

  return {
    dayOptions,     // 表示用の日数候補（1〜月末日）
    correctedDay,   // 補正された「正しい日付」（入力が超えてたら丸める）
    daysInMonth     // 現在の月の日数
  };
};